import {
  Bone,
  FieldSkeleton,
  HeaderSkeleton,
  Line,
  SkeletonRegion,
} from '@ems/ui/patterns/skeleton-blocks'

/** The organization page: three form sections beside the invoice header preview. */
export function OrganizationSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-36" description="w-96" />
      <div className="grid items-start gap-6 xl:grid-cols-[minmax(0,36rem)_minmax(0,1fr)]">
        <div className="flex max-w-2xl flex-col gap-8">
          <div className="flex flex-col gap-4">
            <Line width="w-28" />
            <FieldSkeleton label="w-20" help="w-80" />
            <FieldSkeleton label="w-14" help="w-64" />
          </div>
          <div className="flex flex-col gap-4">
            <Line width="w-16" />
            <FieldSkeleton control="textarea" label="w-16" help="w-48" />
            <div className="grid gap-4 sm:grid-cols-2">
              <FieldSkeleton label="w-12" />
              <FieldSkeleton label="w-10" />
            </div>
            <FieldSkeleton label="w-16" help="w-56" />
          </div>
          <div className="flex flex-col gap-4">
            <Line width="w-24" />
            <div className="grid gap-4 sm:grid-cols-2">
              {['w-28', 'w-20'].map((label) => (
                <div key={label} className="flex flex-col gap-2">
                  <Line size="xs" width={label} className="h-3.5" />
                  <div className="flex items-center gap-3">
                    <Bone className="h-16 w-32" />
                    <div className="flex flex-1 flex-col gap-2">
                      <Line width="w-24" />
                      <Bone className="h-8 w-24" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <FieldSkeleton control="textarea" label="w-14" help="w-72" />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Line size="xs" width="w-24" />
          <div className="flex min-h-48 flex-col justify-between gap-6 rounded-lg border p-5">
            <div className="flex items-start gap-3 border-b-2 pb-3">
              <Bone className="h-10 w-20" />
              <div className="flex flex-1 flex-col items-center gap-1.5">
                <Line width="w-40" />
                <Line size="xs" width="w-48" />
                <Line size="xs" width="w-32" />
                <Line size="xs" width="w-36" />
              </div>
              <Bone className="h-10 w-20" />
            </div>
            <Line size="xs" width="w-56" />
          </div>
        </div>
      </div>
    </SkeletonRegion>
  )
}
